import React from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupText, Row } from "reactstrap";
import queryString from "query-string";
import AlertComponent from "../../../_UI/Components/Alerts/AlertComponent";
import { lexofficeActions } from "../services/store/lexoffice.actions";
import { logout } from "../../../user/services/store/authentication.actions";

class LexOfficeRegistration extends React.Component {
    static CREATE_MODE = 0;
    static EDIT_MODE = 1;

    constructor(props) {
        super(props);

        this.props.dispatch(logout());

        let params = queryString.parse(this.props.location.search);
        this.state = {
            urlParams: params,
            userData: {
                code: params["code"],
                email: params["mail"] || "",
                password: "",
                passwordRepeat: "",
            },
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.register = this.register.bind(this);
    }

    handleChange(e) {
        this.setState({
            userData: {
                ...this.state.userData,
                [e.target.name]: e.target.value,
            },
        });
    }

    register() {
        this.props.dispatch(lexofficeActions.registerOrganization(this.state.userData));
    }

    render() {
        const { lexoffice, userRegistration } = this.props;
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6" xs="12">
                            <CardGroup>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xs="12" className="justify-content-center">
                                                <img
                                                    src={process.env.PUBLIC_URL + "/logo.png"}
                                                    alt="Pathway Logo"
                                                    style={{ maxWidth: "60%" }}
                                                    className="rounded mx-auto d-block"
                                                />
                                                <br />
                                                <br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <AlertComponent
                                                    errorMessages={userRegistration.errorMessage}
                                                    warningMessages={userRegistration.warningMessage}
                                                />
                                                <AlertComponent errorMessages={lexoffice.errorMessage} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <InputGroup className="mb-3" style={{ marginTop: "1em" }}>
                                                    <div className="input-group-append">
                                                        <InputGroupText>
                                                            <i className="icon-user"></i>
                                                        </InputGroupText>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        disabled={this.state.urlParams["mail"]}
                                                        placeholder="E-Mail"
                                                        name="email"
                                                        value={this.state.userData.email}
                                                        onChange={this.handleChange}
                                                    />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <div className="input-group-append">
                                                        <InputGroupText>
                                                            <i className="icon-lock"></i>
                                                        </InputGroupText>
                                                    </div>
                                                    <Input
                                                        type="password"
                                                        placeholder="Passwort"
                                                        name="password"
                                                        value={this.state.userData.password}
                                                        onChange={this.handleChange}
                                                    />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <div className="input-group-append">
                                                        <InputGroupText>
                                                            <i className="icon-lock"></i>
                                                        </InputGroupText>
                                                    </div>
                                                    <Input
                                                        type="password"
                                                        placeholder="Passwort wiederholen"
                                                        name="passwordRepeat"
                                                        value={this.state.userData.passwordRepeat}
                                                        onChange={this.handleChange}
                                                    />
                                                </InputGroup>
                                                <Row>
                                                    <Col>
                                                        {lexoffice.loading ? (
                                                            <button
                                                                className="btn btn-primary"
                                                                type="button"
                                                                onClick={this.register}
                                                            >
                                                                <span
                                                                    className="spinner-border spinner-border-sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>{" "}
                                                                Registrieren
                                                            </button>
                                                        ) : (
                                                            <Button
                                                                color="primary"
                                                                className="px-4 btn btn-primary"
                                                                onClick={this.register}
                                                            >
                                                                Registrieren
                                                            </Button>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    const { authentication, client, integrations, userRegistration } = state;
    const { lexoffice } = integrations;
    return {
        loggingIn,
        authentication,
        client,
        lexoffice,
        userRegistration,
    };
}

export default connect(mapStateToProps)(LexOfficeRegistration);
